export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '/images/flag_usa.svg' },
  { code: 'es', label: 'Español', flag: '/images/flag_spain.svg' },
  { code: 'de', label: 'Deutsch', flag: '/images/flag_germany.svg' },
  { code: 'pt', label: 'Português', flag: '/images/flag_portugal.svg' },
  { code: 'fr', label: 'Français', flag: '/images/flag_france.svg' },
  { code: 'it', label: 'Italiano', flag: '/images/flag_italy.svg' },
] as const
